// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"fbd222b6","375":"8e63f524","419":"43924b06","453":"5d79306b","457":"dd5705c2","482":"b781194c","885":"8b7a1ddf","965":"6f8c9220","983":"25b75784"}[chunkId] + ".chunk.js";
};